import { render, staticRenderFns } from "./NotAvailable.vue?vue&type=template&id=4201b5a5"
import script from "./NotAvailable.vue?vue&type=script&lang=js"
export * from "./NotAvailable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports